import { Icon } from '../../../assets/icons/icons';
import { StatusBadge } from '../../ui/StatusBadge/StatusBadge';
import { PriorityTag } from '../../ui/PriorityTag/PriorityTag';
import { CopyIdButton } from '../CopyIdButton/CopyIdButton';
import { waitingDays } from '../../../hooks/useSupportRequests';
import { ANSWER_SLA_DAYS } from '../../../entities/supportRequests/model/constants';
import { agoLabel, daysLabel, formatDate, formatTime, shortId } from '../../../utils/format';
import { cx } from '../../../utils/cx';
import type { SupportRequest } from '../../../entities/supportRequests/model/types';
import styles from './RequestRow.module.scss';
import React from 'react';

export interface RequestRowProps {
    request: SupportRequest;
    onOpen: (id: string) => void;
}

export function RequestRow({ request, onOpen }: RequestRowProps) {
    const waiting = waitingDays(request);
    const overdue = waiting > ANSWER_SLA_DAYS;

    return (
        <tr className={styles.row} onClick={() => onOpen(request.id)}>
            <td>
                <div className={styles.idCell}>
                    <span className={cx(styles.dot, request.status !== 'new' && styles.dotOff)} />
                    <span className={styles.code}>{shortId(request.id)}</span>
                    <CopyIdButton id={request.id} onlyOnHover />
                </div>
            </td>

            <td>
                <div className={styles.theme}>{request.theme}</div>
                <div className={styles.text}>{request.text}</div>
            </td>

            <td>
                {request.org ? (
                    <div className={styles.org} title={request.org}>
                        {request.org}
                    </div>
                ) : (
                    <div className={cx(styles.org, styles.orgNone)}>Компания не указана</div>
                )}
                <div className={styles.mail}>{request.email}</div>
            </td>

            <td>
                <div>{formatDate(request.createdAt)}</div>
                <div className={styles.dateSub}>
                    {formatTime(request.createdAt)} · {agoLabel(request.createdAt)}
                </div>
                {overdue && (
                    <div className={cx(styles.sla, waiting > 7 && styles.slaLate)}>
                        <Icon name="clock" size={10} strokeWidth={2} />
                        без ответа {daysLabel(waiting)}
                    </div>
                )}
            </td>

            <td>
                <StatusBadge status={request.status} />
            </td>

            <td>
                <PriorityTag priority={request.priority} />
            </td>

            <td>
                <span className={styles.go}>
                    <Icon name="chevronRight" size={14} strokeWidth={2} />
                </span>
            </td>
        </tr>
    );
}
